import React, { useState } from "react";
import PageHeader from "../../components/PageHeader";
import {
  Container,
  Grid,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import Socialmedia from "markup/components/Socialmedia";
import LinesDecor from "markup/components/LinesDecor";
import axiosClient from "axiosClient";
import NewsCardItem from "../../components/NewsCardItem"; 
import { useQuery } from '@tanstack/react-query'; 

// Images
import BgNews from '../../../assets/centrum_assets/design/stations/stationBG.png'
import { auto } from "@popperjs/core";

const News = () => {
  // --- UI STATE ---
  const [visibleCards, setVisibleCards] = useState(6);

  // --- DATA FETCHING (React Query) ---
  const { data: newsData = [], isLoading: loading } = useQuery({
    queryKey: ['news'], // Matches the list key pattern
    queryFn: async () => {
      const response = await axiosClient.get('/article-posts');
      return response.data.data || [];
    },
  });

  // --- HANDLERS ---
  const handleShowMore = () => setVisibleCards(prev => prev + 3);
  const handleShowLess = () => setVisibleCards(6);

  // Calculate remaining cards for alignment logic
  const remainingCards = newsData.slice(0, visibleCards).length % 3;

  return (
    <>
      <PageHeader title="NEWS" pages={[]} />

      <Box
        sx={{
          backgroundImage: `url(${BgNews})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Container maxWidth="lg" sx={{ py: 10}}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#7da242",
              py: 5
              // mt: { xs: 2, sm: 8, md: 10, lg: 8 },
              // mt: 9
            }}
          >
            WHAT'S HAPPENING NOW
          </Typography>
          

          {/* LOADING STATE */}
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
              <CircularProgress sx={{ color: "#009fb6" }} />
            </Box>
          ) : (
            <>
              {/* DYNAMIC GRID */}
              <Grid
                container
                spacing={4}
                // sx={{ pl: { xs: 0, sm: 2, md: 6 } }}
                justifyContent={
                  (remainingCards === 1 || remainingCards === 2) && visibleCards > 6
                    ? "center"
                    : "flex-start"
                }
              >
                {/* Loop through API Data */}
                {newsData.slice(0, visibleCards).map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={item.id || index}>
                    {/* Pass full newsData for context/navigation if needed by card */}
                    <NewsCardItem item={item} newsData={newsData} />
                  </Grid>
                ))}
              </Grid>

              {/* Show More Button */}
              {newsData.length > 6 && visibleCards < newsData.length && (
                <Box textAlign="center" mt={5}>
                  <Button
                    onClick={handleShowMore}
                    variant="contained"
                    sx={{
                      backgroundColor: "#00bbd4",
                      px: 3,
                      borderRadius: "40px",
                      letterSpacing: 2,
                      fontSize: '1.4rem',
                      fontWeight: 550,
                      "&:hover": { backgroundColor: "#009fb6" },
                    }}
                  >
                    Show More
                  </Button>
                </Box>
              )}

              {/* Show Less Button */}
              {visibleCards > 6 && (
                <Box textAlign="center" mt={5}>
                  <Button
                    onClick={handleShowLess}
                    variant="contained"
                    sx={{
                      backgroundColor: "#00bbd4",
                      px: 3,
                      borderRadius: "40px",
                      letterSpacing: 2,
                      fontSize: '1.4rem',
                      fontWeight: 550,
                      "&:hover": { backgroundColor: "#009fb6" },
                    }}
                  >
                    Show Less
                  </Button>
                </Box>
              )}
            </>
          )}
        </Container>
      </Box>
      <Socialmedia/>
      <LinesDecor greenMt={{ xl: -6, lg: -5, md: -4, sm: -2, xs: 1 }} blueMt={{ xl: -0.3, lg: 1, md: 2, sm: 1, xs: 3 }}/>
    </>
  );
};

export default News;